import { FormLabelProps } from '@chakra-ui/react';

import { standard } from './standard';
import { simpleItalic } from './simpleItalic';
import { bold } from './bold';
import { simpleGray } from './simpleGray';

export type VariantsAvailable =
  | 'standard'
  | 'simpleItalic'
  | 'bold'
  | 'simpleGray';

export const variants: Record<VariantsAvailable, FormLabelProps> = {
  standard,
  simpleItalic,
  bold,
  simpleGray,
};
